import { render, staticRenderFns } from "./PorTipoMunicipal.vue?vue&type=template&id=842ee5d0&scoped=true"
import script from "./PorTipoMunicipal.vue?vue&type=script&lang=js"
export * from "./PorTipoMunicipal.vue?vue&type=script&lang=js"
import style0 from "./PorTipoMunicipal.vue?vue&type=style&index=0&id=842ee5d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "842ee5d0",
  null
  
)

export default component.exports